import EmptyBox from 'components/EmptyBox';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect, useRef, useState } from 'react';
// import { useForm } from 'hooks/useForm'
import LaunchIcon from '@mui/icons-material/Launch';
import Button, { ButtonWrapper } from 'blocks/Button';
import Pager from 'components/Pager';
import Table from 'components/Table';
import CheckMilageModal from 'components/modals/CheckMilageModal';
import FlightDetailModal from 'components/modals/FlightDetailModal';
import { ClaimMilesFormModel, FlightResponse, FlightTypeInterface } from './claim.interface';

import axios from 'axios';
import BoxWrapper from 'blocks/BoxWrapper';
import Card from 'blocks/Card';
import Col from 'blocks/Col';
import Row, { RowItem } from 'blocks/Row';
import StatusText from 'blocks/StatusText';
import { Title } from 'blocks/Text';
import Form, { TextField } from 'components/Form';
import { MilageStatus } from 'components/modals/CheckMilageModal/checkMile.interface';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
import ModalSearch from '../components/ModalSearch';
import * as S from './claim.styles';

const ClaimMiles = () => {
  const { t } = useTranslation();
  const checkMilageModal = useRef<any>();
  const flightDetailModal = useRef<any>();

  const { register, handleSubmit } = useForm<ClaimMilesFormModel>();

  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [claimLoading, setClaimLoading] = useState(false);
  const [flights, setFlights] = useState<FlightTypeInterface[]>([]);
  const [pageData, setPageData] = useState({
    count: 0,
    totalPage: 0,
    page: 0,
  });

  // const { inputFields, handleChange } = useForm({
  //     PNR: {
  //         name: 'PNR',
  //         value: '',
  //         type: 'text',
  //         label: 'PNR',
  //     },
  //     eTicket: {
  //         name: 'eTicket',
  //         value: '',
  //         type: 'text',
  //         label: 'eTicket Number',
  //     },
  //     search: {
  //         name: 'search',
  //         value: '',
  //         type: 'text',
  //         placeholder: 'Search',
  //     }
  // })

  useEffect(() => {
    getFlights(pageData.page);
  }, [pageData.page]);

  const showFlightDetail = (flight: FlightTypeInterface): void => {
    flightDetailModal.current.openModal(flight);
  };

  const getFlights = async (page, qeury?: string) => {
    const params = `?page=${page}` + (qeury || '');

    const res = await ajax<FlightResponse>({
      url: urls.flights + params,
      method: 'GET',
    });

    if (!res) return;

    setFlights(res.data);
    setPageData({
      page: res.currentPage,
      count: res.totalItems,
      totalPage: res.totalPages,
    });
  };

  const claimFlight = async (data: ClaimMilesFormModel) => {
    const { PNR, eTicketNumber } = data;

    setClaimLoading(true);

    const res = await axios
      .post(urls.claimFlight, {
        PNR,
      })
      .catch((err) => {
        const status = err.response.status;
        toast.error(err.response.data.message);

        if (status === 403) checkMilageModal.current.openModal(MilageStatus.NotMatch);
        else if (status === 404) checkMilageModal.current.openModal(MilageStatus.Invalid);
      })
      .finally(() => setClaimLoading(false));

    if (!res) return;

    checkMilageModal.current.openModal(MilageStatus.Success, res.data.response);
  };

  const next = (): void => setPageData({ ...pageData, page: pageData.page + 1 });

  const prev = (): void => {
    if (pageData.page === 0) return;

    setPageData({ ...pageData, page: pageData.page - 1 });
  };

  return (
    <WithSidebar>
      <S.Wrapper>
        <S.ClaimMiles as={Col} justify="stretch">
          <S.ClaimMilesTitle>{t('pages.miles.claim.title')}</S.ClaimMilesTitle>

          <S.ClaimMilesContent as={Row}>
            <S.RowItem as={RowItem} width={314}>
              <S.ClaimMileFormBox as={Col}>
                <S.ClaimMilesForm
                  as={Card}
                  space="md"
                  style={{ backgroundImage: `url(/passenger/images/claim-miles-form-bg.jpg)` }}
                >
                  <Form>
                    <BoxWrapper>
                      <TextField
                        dir={'ltr'}
                        control={register('PNR')}
                        label={t('pages.miles.claim.sections.forms.fields.pnr.label')}
                      />
                    </BoxWrapper>
                    {/*
                    <S.ClaimMilesDevider>
                      <S.ClaimMilesDeviderSpan>
                        {t('pages.miles.claim.sections.forms.fieldsDivider')}
                      </S.ClaimMilesDeviderSpan>
                    </S.ClaimMilesDevider>

                    <BoxWrapper>
                      <TextField
                        control={register('eTicketNumber')}
                        label={t('pages.miles.claim.sections.forms.fields.eTicketNumber.label')}
                      />
                    </BoxWrapper> */}

                    <S.ClaimMilesBtnWrap as={ButtonWrapper} justify="center">
                      <Button width={147} loading={claimLoading} onClick={handleSubmit(claimFlight)}>
                        {t('pages.miles.claim.sections.forms.submitCTA')}
                      </Button>
                    </S.ClaimMilesBtnWrap>
                  </Form>
                </S.ClaimMilesForm>
              </S.ClaimMileFormBox>
            </S.RowItem>

            <S.Logs as={Col}>
              <Card>
                <Col>
                  <S.ClaimHeadTabale as={Row} justify="space-between" align="center">
                    <Title>{t('pages.miles.claim.sections.flightRecords.title')}</Title>

                    <div>
                      <TextField
                        onClick={() => setOpenModalSearch(true)}
                        placeholder={t('pages.miles.claim.sections.flightRecords.filter.openerCTA')}
                      />
                    </div>
                  </S.ClaimHeadTabale>

                  {flights.length === 0 ? (
                    <EmptyBox title={t('pages.miles.claim.sections.flightRecords.emptyText')} />
                  ) : (
                    <Table
                      name="flights"
                      head={[
                        { text: t('pages.miles.claim.sections.flightRecords.tables.headers.activity') },
                        { text: t('pages.miles.claim.sections.flightRecords.tables.headers.rewardMiles') },
                        { text: t('pages.miles.claim.sections.flightRecords.tables.headers.tierMiles') },
                        { text: t('pages.miles.claim.sections.flightRecords.tables.headers.source') },
                        { text: t('pages.miles.claim.sections.flightRecords.tables.headers.flightNumber') },
                        {
                          text: t('pages.miles.claim.sections.flightRecords.tables.headers.status'),
                          className: 'status-table',
                        },
                        {
                          text: t('pages.miles.claim.sections.flightRecords.tables.headers.action'),
                          className: 'action-table',
                        },
                      ]}
                      rows={flights.map((item) => [
                        { content: `${item.departure} - ${item.destination}` },
                        { content: item.Transaction?.rewardMilageUsed || '---' },
                        { content: item.Transaction?.tierMilageUsed || '---' },
                        { content: item.source || '---' },
                        { content: item.flightNo },
                        {
                          content: (
                            <S.Middle
                              as={StatusText}
                              color={
                                item.status === 'initiated' || item.status === 'pending'
                                  ? 'warn'
                                  : item.status === 'done' || item.status === 'registered'
                                  ? 'success'
                                  : 'error'
                              }
                            >
                              {item.status}
                            </S.Middle>
                          ),
                          className: 'status-table',
                        },
                        {
                          content: (
                            <Button
                              color="text-button"
                              iconStart={<LaunchIcon />}
                              styleType="text-button"
                              onClick={() => showFlightDetail(item)}
                              size={'large'}
                            />
                          ),
                          className: 'action-table',
                        },
                      ])}
                    />
                  )}
                </Col>
              </Card>
              {flights.length !== 0 && <Pager total={pageData.count} page={pageData.page} next={next} prev={prev} />}
            </S.Logs>
          </S.ClaimMilesContent>
        </S.ClaimMiles>
      </S.Wrapper>

      <CheckMilageModal ref={checkMilageModal} />
      <FlightDetailModal ref={flightDetailModal} />
      <ModalSearch
        open={openModalSearch}
        onClose={() => setOpenModalSearch(false)}
        onSearch={(params: string) => getFlights(0, params)}
        onClearFilter={() => getFlights(0)}
      />
    </WithSidebar>
  );
};

export default ClaimMiles;
